import { Errors } from "../errors"

export default {
  // Generic Errors
  [Errors.GENERIC_ERROR]: "Algo ha salido mal",
  [Errors.INTERNAL_SERVER_ERROR]: "Error interno del servidor",
  [Errors.INVALID_REQUEST_ERROR]: "Solicitud inválida",
  [Errors.TOO_MANY_REQUESTS]: "Demasiadas solicitudes",
  [Errors.INVALID_TYPE]: "Tipo inválido",
  [Errors.INVALID_JSON]: "JSON inválido",
  [Errors.INVALID_UUID]: "UUID inválido",
  [Errors.INVALID_COUNTRY]: "País inválido - usa el código ISO 3166-1 alpha-2",
  [Errors.INVALID_PHONE_NUMBER]: "Número de teléfono inválido",
  [Errors.INVALID_URL]: "URL inválida",
  [Errors.INVALID_OBJECT]: "Objeto inválido",
  [Errors.INVALID_DATE]: "La fecha no es válida",
  [Errors.INVALID_NUMBER]: "El número no es válido",
  [Errors.TIMEOUT]: "La acción ha tardado demasiado",
  [Errors.ID_REQUIRED]: "El ID es requerido",
  [Errors.DATE_RANGE_INVALID]: "El rango de fechas no es válido",
  [Errors.DATE_IN_FUTURE]: "La fecha es futura",
  [Errors.DATE_RANGE_TOO_LONG]: "El rango de fechas es demasiado largo",
  [Errors.IDENTIFIER_REQUIRED]: "Identificador requerido",
  [Errors.IDENTIFIER_ALREADY_EXISTS]: "El identificador ya existe",
  [Errors.FIELD_REQUIRED]: "El campo es requerido",
  [Errors.FIELD_MAX_LENGTH]: "El campo tiene demasiados caracteres",
  [Errors.CONTENT_EXTRACTION_FAILED]: "No se ha podido extraer el contenido",
  [Errors.MISSING_FILE_FIELD]: "Archivo adjunto no encontrado",
  [Errors.ACTION_NOT_SCOPED]: "Esta acción no está asociada a ninguna empresa",
  // Auth
  [Errors.ADMIN_ALREADY_EXISTS]: "El administrador ya existe",
  [Errors.ADMIN_NOT_FOUND]: "Administrador no encontrado",
  [Errors.EMAIL_NOT_CORPORATE]: "El email tiene que ser de una compañía",
  [Errors.EMAIL_INVALID]: "El email es inválido",
  [Errors.EMAIL_REQUIRED]: "El email es requerido",
  [Errors.EMPLOYEE_NOT_FOUND]: "El empleado no existe",
  [Errors.LOGIN_CREDENTIALS_INVALID]: "El email o la contraseña no son válidos",
  [Errors.NAME_REQUIRED]: "El nombre es requerido",
  [Errors.PASSWORD_INVALID]: "La contraseña no es válida",
  [Errors.WEAK_PASSWORD_USED]:
    "La contraseña es débil. No se puede usar esta contraseña en producción.",
  [Errors.PASSWORD_MIN_LENGTH]: "La contraseña debe tener al menos 5 caracteres",
  [Errors.PASSWORD_REQUIRED]: "La contraseña es requerida",
  [Errors.OLD_PASSWORD_INVALID]: "La contraseña antigua no es válida",
  [Errors.PASSWORD_DONT_MATCH]: "Las contraseñas no coinciden",
  [Errors.TOKEN_NOT_FOUND]: "El token no existe",
  [Errors.API_TOKEN_READ_ONLY]: "Este token de API es de solo lectura",
  [Errors.UNAUTHORIZED]: "No autorizado",
  [Errors.ROLE_IS_REQUIRED]: "Selecciona que rol tienes",
  [Errors.WEBSITE_NOT_REACHABLE]:
    "No pudimos acceder al sitio web de tu empresa. Por favor, verifica el dominio del correo e inténtalo de nuevo.",
  [Errors.SETUP_TOKEN_NOT_FOUND]:
    "La sesión de configuración ha expirado. Por favor, empieza de nuevo.",
  // Employees
  [Errors.AVATAR_FILE_SIZE_EXCEEDED]: "El tamaño del avatar es demasiado grande",
  [Errors.EMPLOYEE_ALREADY_EXISTS]: "El empleado ya existe",
  [Errors.EMPLOYEE_EMAIL_INVALID]: "El email del empleado no es válido",
  [Errors.EMPLOYEE_EMAIL_REQUIRED]: "El email del empleado es requerido",
  [Errors.EMPLOYEE_NAME_REQUIRED]: "El nombre del empleado es requerido",
  [Errors.EMPLOYEE_LOCALE_REQUIRED]: "El idioma del empleado es requerido",
  [Errors.EMPLOYEE_PERMISSIONS_REQUIRED]: "Las permisos del empleado son necesarios",
  [Errors.EMPLOYEE_ALREADY_ARCHIVED]: "El empleado ya está archivado",
  [Errors.EMPLOYEE_NOT_ARCHIVED]: "El empleado no está archivado",
  [Errors.CANNOT_ARCHIVE_YOURSELF]: "No puedes archivarte a ti mismo",
  [Errors.EMPLOYEE_ALREADY_OWNER]: "Este empleado ya es el propietario",
  [Errors.INVITATION_ALREADY_SENT]: "La invitación ya ha sido enviada",
  [Errors.INVITATION_NOT_FOUND]: "La invitación no existe",
  [Errors.INVITATION_TOKEN_NOT_FOUND]: "El token de invitación no existe",
  [Errors.LOCALE_REQUIRED]: "El idioma es requerido",
  // Organizations
  [Errors.ORGANIZATION_NOT_FOUND]: "La organización no existe",
  [Errors.ORGANIZATION_SLUG_ALREADY_EXISTS]: "El slug de la organización ya existe",
  [Errors.ORGANIZATION_TYPE_INVALID]: "El tipo de organización no es válido",
  // Companies
  [Errors.COMPANY_NOT_FOUND]: "No se encontró la empresa",
  [Errors.VAULT_ENTRY_NOT_FOUND]: "No se encontró el valor de la caja fuerte",
  [Errors.VAULT_KEY_INVALID]:
    "Usa solo letras, números y guiones bajos, sin empezar por un número. Por ejemplo: MY_API_KEY",
  [Errors.VAULT_SECRET_NOT_ALLOWED]: "Los valores secretos no se pueden usar aquí",
  [Errors.REFERRAL_LEAD_NOT_FOUND]: "No se encontró el lead referido",
  [Errors.COMPANY_ID_REQUIRED]: "El ID de la empresa es necesario",
  [Errors.ORGANIZATION_ID_REQUIRED]: "El ID de la organización es necesario",
  [Errors.COMPANY_ALREADY_EXISTS]: "La empresa ya existe",
  [Errors.COMPANY_NAME_IS_REQUIRED]: "El nombre de la empresa es necesario",
  [Errors.COMPANY_WITHOUT_OWNER]: "La empresa no tiene un propietario",
  [Errors.COMPANY_SLUG_ALREADY_EXISTS]: "El slug de la empresa ya existe",
  [Errors.COMPANY_SIZE_REQUIRED]: "Indica el tamaño de tu compañía",
  [Errors.COMPOSER_CUSTOM_PROMPT_INVALID]:
    "Este contenido entra en conflicto con las reglas del agente",
  // Billing
  [Errors.ORGANIZATION_SUBSCRIPTION_NOT_FOUND]: "El plan de suscripción no existe",
  [Errors.CREDITS_PACKAGE_NOT_FOUND]: "El paquete de créditos no existe",
  [Errors.NO_PACKAGE_CREDITS_AVAILABLE]: "No hay créditos disponibles en el paquete",
  [Errors.STRIPE_CUSTOMER_ID_REQUIRED]: "El ID de cliente de Stripe es necesario",
  [Errors.STRIPE_PRICE_NOT_FOUND]: "El precio de Stripe no existe",
  [Errors.CREDIT_TRANSACTION_NOT_FOUND]: "La transacción de créditos no existe",
  // Customers
  [Errors.CUSTOMER_NOT_FOUND]: "El cliente no existe",
  [Errors.CUSTOMER_METADATA_INVALID]: "Los metadatos no son válidos",
  [Errors.CUSTOMER_NAME_INVALID]: "El nombre no es válido",
  [Errors.CUSTOMER_PHONE_INVALID]: "El teléfono no es válido",
  [Errors.CUSTOMER_USES_CHANNEL]:
    "El cliente usa un canal real, por lo que no se puede enviar un mensaje",
  [Errors.CUSTOMER_EMAIL_NOR_PHONE_FOUND]: "El cliente no tiene teléfono ni correo",
  [Errors.CUSTOMER_NOT_IN_MANUAL_CONTROL]: "El cliente no está en control manual",
  [Errors.CUSTOMER_PHONE_NUMBER_REQUIRED]: "El teléfono del cliente es requerido",
  [Errors.CUSTOMER_WITH_PHONE_ALREADY_EXISTS]: "Ya existe un cliente con este teléfono",
  [Errors.CUSTOMER_WITHOUT_EMAIL_OR_TENTATIVE_EMAIL]:
    "El cliente no tiene email ni email tentativo",
  // Company Clients
  [Errors.COMPANY_CLIENT_NOT_FOUND]: "El cliente de la empresa no existe",
  // Campaigns
  [Errors.CAMPAIGN_INVALID]: "La campaña no es válida",
  [Errors.CAMPAIGN_ID_REQUIRED]: "El ID de la campaña es requerido",
  [Errors.CAMPAIGN_NOT_FOUND]: "La campaña no existe",
  [Errors.CAMPAIGN_NOT_LAUNCHED]: "La campaña no está publicada",
  [Errors.CAMPAIGN_NOT_ACTIVE]: "La campaña no está activa",
  [Errors.CAMPAIGN_STATUS_INVALID]: "El estado de la campaña no es válido",
  [Errors.CAMPAIGN_GOAL_INVALID]: "El objetivo no es válido",
  [Errors.CAMPAIGN_GOALS_REQUIRED]:
    "Se necesita al menos un objetivo que no sea subyacente para campañas outbound",
  [Errors.CAMPAIGN_GOAL_NOT_FOUND]: "El objetivo de la campaña no existe",
  [Errors.CAMPAIGN_TEMPLATES_REQUIRED]: "Se necesita al menos una plantilla",
  [Errors.CAMPAIGN_OPENING_MESSAGES_REQUIRED]: "Se necesita al menos un mensaje de apertura",
  [Errors.CAMPAIGN_TEMPLATE_NOT_FOUND]: "La plantilla no existe",
  [Errors.CAMPAIGN_TRIGGER_INVALID]: "El trigger no es válido",
  [Errors.CAMPAIGN_TRIGGER_NOT_FOUND]: "El trigger no existe",
  [Errors.CAMPAIGN_SCHEDULE_IN_PAST]: "La hora de lanzamiento debe ser futura",
  [Errors.CAMPAIGN_LAUNCH_NOT_FOUND]: "El lanzamiento no existe",
  [Errors.CAMPAIGN_LAUNCH_NOT_SCHEDULED]: "Este lanzamiento ya ha empezado o se ha cancelado",
  [Errors.CAMPAIGN_CONDITION_INVALID]: "La condición no es válida",
  [Errors.CAMPAIGN_ACTION_INVALID]: "Las acciones de la campaña no son válidas",
  [Errors.CAMPAIGN_EVENT_INVALID]: "Los eventos de la campaña no son válidos",
  [Errors.CAMPAIGN_EVENT_WITHOUT_ACTION]: "Cada evento debe tener al menos una acción",
  [Errors.WORKFLOW_IMPORT_INVALID_FILE]:
    "Este archivo fue modificado o no es un archivo de workflow de Permut válido",
  [Errors.CAMPAIGN_CHANNEL_REQUIRED]: "Define al menos un canal",
  [Errors.CAMPAIGN_DEFAULT_LANGUAGE_REQUIRED]: "Define un idioma predeterminado",
  [Errors.CAMPAIGN_DEFAULT_LANGUAGE_TEMPLATE_REQUIRED]:
    "Añade una plantilla activa para el idioma predeterminado",
  [Errors.CAMPAIGN_ALREADY_ARCHIVED]: "La campaña ya está archivada",
  [Errors.CAMPAIGN_NOT_ARCHIVED]: "La campaña no está archivada",
  [Errors.CAMPAIGN_NODE_NOT_FOUND]: "El nodo de la campaña no existe",
  [Errors.CAMPAIGN_NODE_TYPE_NOT_FOUND]: "El tipo de nodo de la campaña no existe",
  [Errors.CAMPAIGN_TRIGGER_QR_WITHOUT_QR]: "La campaña requiere un QR",
  [Errors.CAMPAIGN_TRIGGER_INSTAGRAM_WITHOUT_ACCOUNT]:
    "La campaña requiere una cuenta de Instagram",
  [Errors.CAMPAIGN_TRIGGER_MESSENGER_WITHOUT_PAGE]: "La campaña requiere una página de Facebook",
  [Errors.CAMPAIGN_CHANNEL_GMAIL_WITHOUT_ACCOUNT]: "La campaña requiere una cuenta de Gmail",
  [Errors.CAMPAIGN_CHANNEL_OUTLOOK_WITHOUT_ACCOUNT]: "La campaña requiere una cuenta de Outlook",
  [Errors.CAMPAIGN_TRIGGER_INSTAGRAM_INVALID_AUDIENCE]:
    "Audiencia inválida en campaña de Instagram",
  [Errors.CAMPAIGN_TRIGGER_INSTAGRAM_INVALID_REPLY]:
    "Se requiere al menos una respuesta de comentario en Instagram",

  [Errors.CAMPAIGN_NUMBER_OR_INTEGRATION_ID_REQUIRED]:
    "La campaña requiere un número de Whatsapp o integración de email",
  [Errors.CAMPAIGN_WHATSAPP_DEFAULT_IMMUTABLE]:
    "El trigger y canal del campaign por defecto de WhatsApp no puede modificarse",
  [Errors.CAMPAIGN_CALLBACK_URL_REQUIRED]:
    "La URL de callback es obligatoria para campañas con canal API",
  [Errors.CAMPAIGN_CALLBACK_URL_INVALID]: "Introduce una URL de callback http o https válida",
  [Errors.CAMPAIGN_CALLBACK_URL_MISSING_REFERENCE_ID_MACRO]:
    "La URL debe incluir referenceId en la ruta o como parámetro de consulta llamado referenceId",
  [Errors.CAMPAIGN_FLOW_REQUIRED]: "El flujo de la campaña es obligatorio",
  // Clusters
  [Errors.CLUSTER_SNAPSHOT_NOT_FOUND]: "El snapshot del cluster no existe",
  [Errors.CANONICAL_TOPIC_NOT_FOUND]: "El tópico canónico no existe",
  // Conversations
  [Errors.CONVERSATION_NOT_FOUND]: "La conversación no existe",
  [Errors.CONVERSATION_ALREADY_ACTIVE]: "La conversación ya está activa",
  [Errors.CONVERSATION_IS_NOT_TESTING]: "La conversación no está en modo de prueba",
  [Errors.CONVERSATION_IS_NOT_CAMPAIGN]: "La conversación no es una campaña",
  [Errors.CONVERSATION_ALREADY_HAS_MESSAGES]: "La conversación ya tiene mensajes",
  [Errors.CONVERSATION_NOT_STARTED]: "La conversación no ha empezado",
  [Errors.CONVERSATION_RESPONSE_NOT_FOUND]: "La respuesta de la conversación no existe",
  [Errors.CONVERSATION_OPPORTUNITY_NOT_FOUND]: "La oportunidad de la conversación no existe",
  [Errors.CONVERSATION_ORDER_ACTION_NOT_FOUND]: "Acción de pedido en conversación no encontrada",
  [Errors.SHORT_LINK_NOT_FOUND]: "Enlace corto no encontrado",
  // Goals
  [Errors.GOAL_NOT_FOUND]: "El objetivo no existe",
  [Errors.GOAL_ASSISTANT_INSTRUCTIONS_REQUIRED]:
    "Las instrucciones del asistente son necesarias para este tipo de objetivo",
  [Errors.GOAL_OPTIONS_REQUIRED]: "Opciones para el objetivo necesarias",
  [Errors.GOAL_OPTIONS_MIN_REQUIRED]: "Se requieren al menos 2 opciones",
  [Errors.GOAL_OPTIONS_MAX_REQUIRED]: "Máximo 10 opciones permitidas",
  [Errors.GOAL_OPTIONS_NPS_REQUIRED]: "Las opciones NPS son necesarias para el objetivo",
  [Errors.CONVERSATION_GOAL_NOT_FOUND]: "El objetivo de la conversación no existe",
  [Errors.GOAL_MEDIA_UPLOAD_ERROR]: "Error al subir multimedia al objetivo",
  [Errors.GOAL_NAME_ALREADY_EXISTS]: "Ya existe un objetivo con ese nombre",
  // Klaviyo
  [Errors.KLAVIYO_INTEGRATION_NOT_FOUND]: "Integración de Klaviyo no encontrada",
  // Messages
  [Errors.MESSAGE_NOT_FOUND]: "El mensaje no existe",
  [Errors.MESSAGE_IDENTIFIER_NOT_FOUND]: "El identificador de mensaje no existe",
  // Meta
  [Errors.WHATSAPP_TEMPLATE_NOT_FOUND]: "La plantilla de WhatsApp no existe",
  [Errors.WHATSAPP_TEMPLATE_ALREADY_EXISTS]: "La plantilla de WhatsApp ya existe",
  [Errors.WHATSAPP_TEMPLATE_ALREADY_PENDING]:
    "La plantilla de WhatsApp ya está pendiente de aprobación",
  [Errors.WHATSAPP_TEMPLATE_INVALID_TEMPLATE]: "Plantilla no válida",
  [Errors.WHATSAPP_TEMPLATE_VARIABLE_AT_EDGE]:
    "Las variables no pueden estar al principio ni al final de la plantilla. Añade texto fijo alrededor.",
  [Errors.WHATSAPP_TEMPLATE_INVALID_VARIABLES]: "Las variables de la plantilla no son válidas",
  [Errors.WHATSAPP_TEMPLATE_VARIABLE_NAME_INVALID]:
    'El nombre de la variable no es válido, solo se permiten letras minúsculas y "_"',
  [Errors.WHATSAPP_TEMPLATE_VARIABLE_EXAMPLE_REQUIRED]: "El ejemplo es necesario",
  [Errors.WHATSAPP_INTEGRATION_NOT_FOUND]: "Integración de Whatsapp no encontrada",
  [Errors.WHATSAPP_NUMBER_NOT_FOUND]: "El número de Whatsapp no existe",
  [Errors.WHATSAPP_OPENING_MESSAGE_NOT_FOUND]: "Mensaje de apertura de Whatsapp no encontrado",
  [Errors.WHATSAPP_EXCHANGE_TOKEN_ERROR]: "Error al generar el exchange token",
  [Errors.WHATSAPP_SUBSCRIBED_APP_ERROR]: "Error al subscribir a la app de Permut",
  [Errors.WHATSAPP_DOWNLOAD_MEDIA_FAILED]: "Error al descargar archivo",
  [Errors.WHATSAPP_PREPARE_MEDIA_FAILED]: "Error al preparar archivo",
  [Errors.WHATSAPP_UPLOAD_MEDIA_FAILED]: "Error al subir archivo",
  [Errors.WHATSAPP_MESSAGE_HANDLER_FAILED]: "Error al procesar mensaje de Whatsapp",
  [Errors.WHATSAPP_TEMPLATE_EDIT_24H]: "Las plantillas de Whatsapp sólo pueden editarse cada 24h",
  [Errors.WHATSAPP_ERROR_UPDATING_TEMPLATE]: "Error al editar la plantilla de Whatsapp",
  [Errors.WHATSAPP_ERROR_VERIFYING_NUMBER]: "Error al verificar número de teléfono",
  // SalesForce
  [Errors.SALES_FORCE_INTEGRATION_NOT_FOUND]: "Integración de SalesForce no encontrada",
  [Errors.SALES_FORCE_KEYMAP_NOT_FOUND]: "Relación Key-Map de SalesForce no encontrada",
  // S3
  [Errors.S3_DOWNLOAD_ERROR]: "Error al descargar el archivo",
  [Errors.S3_NOT_CONFIGURED]: "S3 no está configurado",
  [Errors.S3_UPLOAD_ERROR]: "Error al subir el archivo",
  [Errors.S3_UPLOAD_FILE_TYPE_INVALID]: "El tipo de archivo no es válido",
  // Dashboard
  [Errors.ERROR_PROCESSING_CLUSTERS]: "Error agrupando la información",
  // Knowledge Base
  [Errors.KNOWLEDGE_BASE_ITEM_NOT_FOUND]: "Entrada de la base de conocimientos no encontrada",
  [Errors.KNOWLEDGE_BASE_ITEM_CONTENT_INVALID]: "El contenido no es válido",
  [Errors.KNOWLEDGE_BASE_UNSUPPORTED_FILE_FORMAT]:
    "Formato de archivo no soportado. Solo se permiten archivos PDF, PNG, JPEG, WebP y GIF.",
  [Errors.KNOWLEDGE_BASE_FILE_SIZE_EXCEEDED]:
    "El tamaño del archivo excede el tamaño máximo permitido de 20 MB",
  [Errors.WEBPAGE_NOT_FOUND]: "Página web no encontrada",
  [Errors.KNOWLEDGE_BASE_ITEM_ALREADY_EXISTS]:
    "Ya existe una entrada igual en la base de conocimiento",
  // Conversation Tickets & Questions
  [Errors.CONVERSATION_TICKET_NOT_FOUND]: "Ticket de conversación no encontrado",
  [Errors.ISSUE_NOT_FOUND]: "Ticket no encontrado",
  [Errors.CONVERSATION_QUESTION_NOT_FOUND]: "Pregunta de conversación no encontrada",
  [Errors.LOGISTICS_TICKET_INTEGRATION_NOT_FOUND]:
    "Integración de ticket de logística no encontrada",
  // Shopify Integration
  [Errors.SHOPIFY_INTEGRATION_NOT_FOUND]: "Integración de Shopify no encontrada",
  [Errors.SHOPIFY_INTEGRATION_INVALID]: "Integración de Shopify inválida",
  [Errors.SHOPIFY_CUSTOMER_ORDERs_NOT_FOUND]: "Pedidos del cliente de Shopify no encontrados",
  [Errors.SHOPIFY_ORDER_NOT_FOUND]: "Pedido de Shopify no encontrada",
  [Errors.SHOPIFY_ORDER_MISMATCH_EMAIL]:
    "El email del pedido de Shopify no coincide con el email del cliente",
  [Errors.SHOPIFY_ORDER_MISMATCH_CONTACT]:
    "El contacto del pedido de Shopify no coincide con el contacto proporcionado",
  [Errors.SHOPIFY_ORDER_MISMATCH_ID]:
    "El ID del pedido de Shopify no coincide con el ID de pedido proporcionado",
  [Errors.SHOPIFY_CUSTOMER_NOT_FOUND]: "Cliente de Shopify no encontrado",
  [Errors.SHOPIFY_REFUND_ORDER_NOT_FOUND]: "Refund de pedido de Shopify no encontrado",
  [Errors.SHOPIFY_REQUEST_ERROR]: "Error en la petición a Shopify",
  [Errors.SHOPIFY_REQUEST_PARSE_INVALID]: "Esquema para respuesta de Shopify inválido",
  [Errors.SHOPIFY_CATALOG_SEARCH_ERROR]: "Error al buscar en el catálogo de Shopify",
  [Errors.SHOPIFY_PRODUCT_FETCH_ERROR]: "Error al obtener productos de Shopify",
  [Errors.SHOPIFY_UNAUTHORIZED]:
    "La autorización de Shopify ha caducado. Por favor, vuelve a conectar la integración de Shopify",
  [Errors.SHOPIFY_LOCATIONS_ACCESS_DENIED]:
    "Acceso a localizaciones denegado. Por favor, concede permisos a la app de Shopify",
  [Errors.SHOPIFY_SIZE_CHARTS_DISABLED]:
    "La conversión de tablas de tallas está desactivada para esta integración de Shopify. Actívala en la configuración de la integración",
  // Importers
  [Errors.EXCEL_WORKBOOK_EMPTY]: "El archivo Excel está vacío",
  [Errors.EXCEL_WORKBOOK_INVALID_DATA]: "El archivo Excel contiene datos inválidos",
  [Errors.EXCEL_WORKBOOK_INVALID_FORMAT]:
    "El archivo subido no es un archivo Excel válido. Por favor, sube un archivo .xlsx.",
  [Errors.CUSTOMER_IMPORT_NOT_FOUND]: "Importación de clientes no encontrada",
  [Errors.CUSTOMER_IMPORT_TOO_LARGE]:
    "Esta importación es demasiado grande. Por favor, divide el archivo en lotes más pequeños.",
  // QRs
  [Errors.QR_NOT_FOUND]: "QR no encontrado",
  [Errors.QR_WITHOUT_CAMPAIGN]: "QR sin campaña",
  // Opening messages
  [Errors.OPENING_MESSAGE_TEXT_NO_IDENTIFIER_VARIABLE]:
    "El mensaje debe contener la variable {{identifier}}",
  // Segments
  [Errors.SEGMENT_ALREADY_EXISTS]: "Ya existe un segmento con ese nombre",
  [Errors.SEGMENT_NOT_FOUND]: "Segmento no encontrado",
  [Errors.SEGMENT_CUSTOMER_NOT_FOUND]: "El cliente no se encuentra en el segmento",
  [Errors.SEGMENT_GROUP_NOT_FOUND]: "Grupo de segmento no encontrado",
  [Errors.SEGMENT_GROUP_ALREADY_EXISTS]: "Ya existe ese grupo de segmento",
  [Errors.ONE_SEGMENT_RULE_REQUIRED]: "Se requiere al menos una regla de segmento",
  // BigBlue
  [Errors.BIGBLUE_REQUEST_ERROR]: "Error en la petición a BigBlue",
  [Errors.BIGBLUE_INTEGRATION_NOT_FOUND]: "Integración de BigBlue no encontrada",
  [Errors.BIGBLUE_ORDER_NOT_FOUND]: "Pedido de BigBlue no encontrado",
  [Errors.BIGBLUE_ORDER_MISMATCH_EMAIL]:
    "El email del pedido de BigBlue no coincide con el email del cliente",
  [Errors.BIGBLUE_ORDER_MISMATCH_ID]:
    "El ID del pedido de BigBlue no coincide con el ID de pedido proporcionado",
  // Reveni
  [Errors.REVENI_INTEGRATION_NOT_FOUND]: "Integración de Reveni no encontrada",
  [Errors.REVENI_RETURN_NOT_FOUND]: "Devolución de Reveni no encontrada",
  [Errors.REVENI_RETURN_MISMATCH_EMAIL]:
    "El email de la devolución de Reveni no coincide con el email del cliente",
  [Errors.REVENI_RETURN_MISMATCH_ID]:
    "El ID del pedido de la devolución de Reveni no coincide con el ID de pedido proporcionado",
  [Errors.REVENI_REQUEST_ERROR]: "Error en la petición a Reveni",
  // LoopReturns
  [Errors.LOOP_RETURNS_INTEGRATION_NOT_FOUND]: "Integración de Loop Returns no encontrada",
  [Errors.LOOP_RETURNS_RETURN_NOT_FOUND]: "Devolución de Loop Returns no encontrada",
  [Errors.LOOP_RETURNS_RETURN_MISMATCH_EMAIL]:
    "El email de la devolución de Loop Returns no coincide con el email del cliente",
  [Errors.LOOP_RETURNS_RETURN_MISMATCH_ID]:
    "El ID del pedido de la devolución de Loop Returns no coincide con el ID de pedido proporcionado",
  [Errors.LOOP_RETURNS_REQUEST_ERROR]: "Error en la petición a Loop Returns",
  // Rever
  [Errors.REVER_INTEGRATION_NOT_FOUND]: "Integración de Rever no encontrada",
  [Errors.REVER_RETURN_NOT_FOUND]: "Devolución de Rever no encontrada",
  [Errors.REVER_RETURN_MISMATCH_EMAIL]:
    "El email de la devolución de Rever no coincide con el email del cliente",
  [Errors.REVER_RETURN_MISMATCH_ID]:
    "El ID del pedido de la devolución de Rever no coincide con el ID de pedido proporcionado",
  [Errors.REVER_REQUEST_ERROR]: "Error en la petición a Rever",
  // Zendesk
  [Errors.ZENDESK_INTEGRATION_NOT_FOUND]: "Integración de Zendesk no encontrada",
  [Errors.ZENDESK_INVALID_CREDENTIALS]:
    "Las credenciales de Zendesk no son válidas. Por favor, verifícalas y vuelve a intentarlo.",
  [Errors.ZENDESK_TOKEN_REQUIRED]: "El token es requerido",
  [Errors.ZENDESK_COMPANY_SUBDOMAIN_REQUIRED]: "El subdominio de la empresa es requerido",
  [Errors.ZENDESK_SUBJECT_TITLE_REQUIRED]: "El título del ticket es requerido",
  // Gorgias
  [Errors.GORGIAS_INTEGRATION_NOT_FOUND]: "Integración de Gorgias no encontrada",
  [Errors.GORGIAS_INVALID_CREDENTIALS]:
    "Las credenciales de Gorgias no son válidas. Por favor, verifícalas y vuelve a intentarlo.",
  [Errors.GORGIAS_SUBJECT_REQUIRED]: "El asunto es requerido",
  [Errors.GORGIAS_BODY_REQUIRED]: "El cuerpo es requerido",
  [Errors.GORGIAS_BASE_API_URL_REQUIRED]: "La URL base de la API es requerida",
  [Errors.GORGIAS_TOKEN_REQUIRED]: "El token es requerido",
  [Errors.GORGIAS_USERNAME_REQUIRED]: "El nombre de usuario es requerido",
  // FrontApp
  [Errors.FRONTAPP_INTEGRATION_NOT_FOUND]: "Integración de FrontApp no encontrada",
  [Errors.FRONTAPP_INVALID_CREDENTIALS]:
    "Las credenciales de FrontApp no son válidas. Por favor, verifícalas y vuelve a intentarlo.",
  [Errors.FRONTAPP_SUBJECT_REQUIRED]: "El asunto es requerido",
  [Errors.FRONTAPP_BODY_REQUIRED]: "El cuerpo es requerido",
  [Errors.FRONTAPP_TOKEN_REQUIRED]: "El token es requerido",
  // Widget
  [Errors.WIDGET_CONVERSATION_SLUG_NOT_FOUND]: "Conversación no encontrada",
  [Errors.WIDGET_BUBBLE_IMAGE_FILE_NOT_FOUND]: "Imagen para icono del widget no encontrada",
  [Errors.WIDGET_IFRAME_BACKGROUND_IMAGE_FILE_NOT_FOUND]:
    "Imagen de fondo para iframe del widget no encontrada",
  // Company integration configuration
  [Errors.COMPANY_INTEGRATION_CONFIGURATION_NOT_FOUND]:
    "Configuración de integraciones de la compañía no encontrada",
  [Errors.COMPANY_INTEGRATION_CONFIGURATION_FIND_ORDER_DISABLED]:
    "Buscar pedido no está habilitado en la configuración de integraciones de la compañía",
  [Errors.COMPANY_INTEGRATION_CONFIGURATION_CHECK_RETURN_DISABLED]:
    "Comprobar la devolución de pedido no está habilitado en la configuración de integraciones de la compañía",
  [Errors.COMPANY_INTEGRATION_CONFIGURATION_CANCEL_ORDER_DISABLED]:
    "Cancelar pedido no está habilitado en la configuración de integraciones de la compañía",
  // Cancelled Orders
  [Errors.CANCELLATION_REASON_REQUIRED]: "Razón de cancelación requerida",
  // Insights
  [Errors.INSIGHT_SIGNAL_NOT_FOUND]: "Señal no encontrada",
  [Errors.INSIGHT_SIGNAL_EMPLOYEE_SOLUTION_NOT_FOUND]:
    "Solución de señal de empleado no encontrada",
  // Instagram
  [Errors.INSTAGRAM_INTEGRATION_NOT_FOUND]: "Integración de Instagram no encontrada",
  [Errors.INSTAGRAM_PROFILE_NOT_FOUND]: "Perfil de instagram no encontrado",
  [Errors.INSTAGRAM_ACCESS_TOKEN_ERROR]: "Error al generar token de acceso a Instagram",
  [Errors.INSTAGRAM_LONG_LIVED_ACCESS_TOKEN_ERROR]:
    "Error al generar token de largo acceso a Instagram",
  [Errors.INSTAGRAM_REFRESH_TOKEN_ERROR]: "Error al regenerar token de acceso a Instagram",
  [Errors.INSTAGRAM_CAMPAIGN_NOT_FOUND]: "Relación entre cuenta Instagram y campaña no encontrada",
  [Errors.INSTAGRAM_MEDIA_NOT_FOUND]: "Contenido no encontrado en Instagram",
  [Errors.INSTAGRAM_ERROR_REPLY_COMMENT]: "Error al responder comentario de Instagram",
  [Errors.INSTAGRAM_SUBSCRIBE_APP_ERROR]: "Error al subscribirse a la app de Instagram",
  [Errors.INSTAGRAM_NO_ACCOUNTS]: "No se compartió ninguna cuenta de Instagram al conectar",
  // Messenger
  [Errors.MESSENGER_INTEGRATION_NOT_FOUND]: "Integración de Messenger no encontrada",
  [Errors.MESSENGER_NO_PAGES]: "No se compartió ninguna página de Facebook al conectar",
  [Errors.MESSENGER_SUBSCRIBE_APP_ERROR]: "Error al subscribir la página de Facebook",
  [Errors.MESSENGER_ERROR_REPLY_COMMENT]: "Error al responder comentario de Facebook",
  // Meta
  [Errors.META_EXCHANGE_TOKEN_ERROR]: "Error al generar token de acceso de Meta",
  // Change Log
  [Errors.CHANGE_LOG_NOT_FOUND]: "Registro de cambios no encontrado",
  // Capabilities
  [Errors.CAPABILITY_NOT_FOUND]: "Capacidad no encontrada",
  [Errors.MCP_CONNECTION_FAILED]: "Error al conectar con el servidor MCP",
  [Errors.MCP_EXECUTION_TIMEOUT]: "La ejecución de la herramienta MCP ha tardado demasiado",
  [Errors.MCP_TOOL_EXECUTION_FAILED]: "Error al ejecutar la herramienta MCP",
  [Errors.MCP_TOOL_NOT_FOUND]: "Herramienta MCP no encontrada",
  [Errors.MCP_INVALID_AUTH]: "Credenciales de autenticación MCP inválidas",
  [Errors.CAPABILITY_CONFIG_INVALID]: "Configuración de capacidad inválida",
  [Errors.CAPABILITY_NOT_AVAILABLE]:
    "La capacidad no está disponible porque falta la integración requerida",
  [Errors.CAPABILITY_ALREADY_INSTALLED]: "La capacidad ya está instalada",
  [Errors.CAPABILITY_CANNOT_BE_ENABLED]: "La capacidad no puede ser habilitada",
  [Errors.CAPABILITY_EXECUTION_NOT_FOUND]: "Ejecución de capacidad no encontrada",
  // Amphora
  [Errors.AMPHORA_INTEGRATION_NOT_FOUND]: "Integración de Amphora no encontrada",
  [Errors.AMPHORA_INTEGRATION_INVALID]: "Integración de Amphora inválida",
  [Errors.AMPHORA_ORDER_NOT_FOUND]: "Pedido de Amphora no encontrado",
  [Errors.AMPHORA_ORDER_NO_EMAIL]:
    "No es posible comprobar el estado de la orden porque la orden no tiene correo. El ticket se escalará.",
  [Errors.AMPHORA_ORDER_MISMATCH_EMAIL]:
    "El email del pedido de Amphora no coincide con el email del cliente",
  [Errors.AMPHORA_ORDER_MISMATCH_ID]:
    "El ID del pedido de Amphora no coincide con el ID de pedido proporcionado",
  [Errors.AMPHORA_REQUEST_ERROR]: "Error al realizar una solicitud a Amphora",
  [Errors.AMPHORA_REQUEST_PARSE_INVALID]: "Error al procesar la respuesta de Amphora",
  [Errors.AMPHORA_TICKET_NOT_FOUND]: "Ticket de Amphora no encontrado",
  [Errors.AMPHORA_CUSTOMER_CANNOT_BE_CONTACTED]: "El cliente no puede ser contactado",
  [Errors.AMPHORA_OWN_WHATSAPP_REQUIRED]:
    "Para activar WhatsApp en las comunicaciones de Amphora, tu organización debe tener su propia cuenta de WhatsApp Business integrada.",
  [Errors.AMPHORA_LOGISTICS_LANGUAGES_REQUIRED]:
    "Selecciona al menos un idioma de plantilla para las comunicaciones logísticas de Amphora por WhatsApp.",
  [Errors.AMPHORA_LOGISTICS_WHATSAPP_NUMBER_REQUIRED]:
    "Añade un número de WhatsApp conectado para esta empresa antes de activar las comunicaciones logísticas de Amphora por WhatsApp.",
  // Backoffice
  [Errors.BACKOFFICE_SCHEDULED_REPORT_NOT_FOUND]: "Informe programado no encontrado",
  [Errors.BACKOFFICE_SCHEDULED_REPORT_ALIAS_ALREADY_EXISTS]:
    "El alias de informe programado ya existe",
  // Google sheets
  [Errors.GOOGLE_SHEETS_MISSING_PERMISSIONS]: "Faltan permisos para este Google sheet",
  [Errors.GOOGLE_SHEETS_ERROR_WRITING]: "Error al escribir en Google sheet",
  [Errors.GOOGLE_SHEETS_RANGE_NOT_FOUND]: "Rango en Google sheet no encontrado",
  // Notes
  [Errors.NOTE_NOT_FOUND]: "Nota no encontrada",
  [Errors.NOTE_MENTION_NOT_FOUND]: "Mención a nota no encontrada",
  // Gmail integration
  [Errors.GMAIL_INTEGRATION_NOT_FOUND]: "Integración de Gmail no encontrada",
  [Errors.GMAIL_INTEGRATION_ERROR_GENERATING_TOKENS]: "Error al generar tokens de Gmail",
  [Errors.GMAIL_INTEGRATION_MISSING_SCOPES]: "Faltan permisos requeridos de Gmail",
  [Errors.GMAIL_USERINFO_NO_EMAIL]: "No se ha encontrado un email en Gmail userinfo",
  [Errors.GMAIL_TOKEN_REFRESH_FAILED]:
    "Error al refrescar el token de acceso de Gmail. Vuelve a conectar Gmail.",
  [Errors.GMAIL_CAMPAIGN_RELATION_NOT_FOUND]: "Relación cuenta Gmail a campaña no encontrada",
  // Outlook integration
  [Errors.OUTLOOK_INTEGRATION_NOT_FOUND]: "Integración de Outlook no encontrada",
  [Errors.OUTLOOK_INTEGRATION_ERROR_GENERATING_TOKENS]: "Error al generar tokens de Outlook",
  [Errors.OUTLOOK_INTEGRATION_MISSING_SCOPES]: "Faltan permisos requeridos de Outlook",
  [Errors.OUTLOOK_USERINFO_NO_EMAIL]: "No se ha encontrado un email en el perfil de Outlook",
  [Errors.OUTLOOK_TOKEN_REFRESH_FAILED]: "Error al refrescar el token de acceso de Outlook",
  [Errors.OUTLOOK_GRAPH_REQUEST_FAILED]: "Ha fallado la request Graph a Outlook",
}
